import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WORKFLOW_FEATURE_KEY, WorkflowState } from './workflow.reducers';

const selectFeatureStepsState = createFeatureSelector<WorkflowState>(WORKFLOW_FEATURE_KEY);

export const selectWorkflowOrigin = createSelector(
    selectFeatureStepsState,
    (state: WorkflowState) => state.workflowOrigin,
);
export const selectWorkflowType = createSelector(selectFeatureStepsState, (state: WorkflowState) => state.workflowType);
export const selectAllSteps = createSelector(selectFeatureStepsState, (state: WorkflowState) => state.steps);

export const selectActivatedStep = createSelector(selectFeatureStepsState, (state: WorkflowState) =>
    state.steps.find(x => x.workflowStepType === state.activatedStep),
);

export const selectPreviouslyActivatedStep = createSelector(selectFeatureStepsState, (state: WorkflowState) =>
    state.steps.find(x => x.workflowStepType === state.previouslyActivatedStep),
);
